// extracted by mini-css-extract-plugin
module.exports = {"ui_toggle_switch":"ToggleSwitch_ui_toggle_switch__MzG3c","title":"ToggleSwitch_title__3PYJL"};